import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";

function two(s) {
  return s.toString().padStart(2, "0");
}

export function fromNow(d, now) {
  if (now === void 0) {
    now = new Date();
  }

  var elapsedMs = now.getTime() - d.getTime();
  var elapsedSec = Math.floor(elapsedMs / 1000);
  var ONE_MINUTE = 1 * 60;
  var ONE_HOUR = ONE_MINUTE * 60;
  var ONE_DAY = ONE_HOUR * 24;
  var ONE_YEAR = ONE_DAY * 365;

  if (elapsedSec < ONE_MINUTE) {
    return "刚刚";
  } else if (elapsedSec < ONE_HOUR) {
    var elapsedMin = Math.floor(elapsedSec / ONE_MINUTE);
    return elapsedMin + "\u5206\u949F\u524D";
  } else if (elapsedSec < ONE_DAY) {
    return two(d.getHours()) + ":" + two(d.getMinutes());
  } else if (elapsedSec < ONE_YEAR) {
    return two(d.getMonth() + 1) + "-" + two(d.getDate());
  } else {
    return d.getFullYear() + "-" + two(d.getMonth() + 1) + "-" + two(d.getDate());
  }
}
export function getChatTimeMarker(d, now) {
  if (now === void 0) {
    now = new Date();
  }

  var ONE_MINUTE = 1 * 60;
  var ONE_HOUR = ONE_MINUTE * 60;
  var ONE_DAY = ONE_HOUR * 24;
  var ONE_YEAR = ONE_DAY * 365;
  var elapsedMs = now.getTime() - d.getTime();
  var elapsedSec = Math.floor(elapsedMs / 1000);
  var elapsedMin = Math.floor(elapsedSec / ONE_MINUTE);
  var day = d.getDay();
  var dayOfToday = now.getDay();
  var getHourAndMinutes = "";

  if (d.getHours() < 12) {
    getHourAndMinutes = "\u4E0A\u5348 " + d.getHours() + ":" + two(d.getMinutes());
  } else if (d.getHours() === 12) {
    getHourAndMinutes = "\u4E0B\u5348 12:" + two(d.getMinutes());
  } else {
    getHourAndMinutes = "\u4E0B\u5348 " + (d.getHours() - 12) + ":" + two(d.getMinutes());
  }

  if (day === dayOfToday && elapsedMin < 24 * 12) {
    return getHourAndMinutes;
  } else if (elapsedSec < ONE_YEAR) {
    return two(d.getMonth() + 1) + "-" + two(d.getDate()) + " " + getHourAndMinutes;
  } else {
    return d.getFullYear() + "-" + two(d.getMonth() + 1) + "-" + two(d.getDate()) + " " + getHourAndMinutes;
  }
}